import { Box, Stack } from '@mui/material';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';
import NotificationBannerProps from './types';
import { IconSvg } from '@/components/Icon';
const getBgColor = (type: NotificationBannerProps['type']) => {
  switch (type) {
    case 'info':
      return 'glass.primary.bg';
    case 'warning':
      return 'background.warning.bg3';
    default:
      return 'glass.negative';
  }
};
const getColor = (type: NotificationBannerProps['type']) => {
  switch (type) {
    case 'warning':
      return 'text.warning';
    case 'info':
      return 'primaryBrand.text';
    default:
      return 'text.text2';
  }
};
const NotificationBanner = ({
  children,
  type = 'info',
  sx,
  icon = true,
  ...props
}: NotificationBannerProps) => {
  return <Stack {...props} sx={{
    width: '100%',
    color: getColor(type),
    p: 'var(--spacing_s)',
    bgcolor: getBgColor(type),
    borderWidth: 1,
    borderColor: 'stroke.stroke',
    borderStyle: 'solid',
    borderRadius: 'var(--corner_radius_m)',
    ...sx
  }} data-sentry-element="Stack" data-sentry-component="NotificationBanner" data-sentry-source-file="index.tsx">
      <Stack direction='row' gap='var(--spacing_xs)' alignItems='start' data-sentry-element="Stack" data-sentry-source-file="index.tsx">
        {type === 'warning' && icon ? <Box sx={{
        width: 24,
        minWidth: 24
      }}>
            {typeof icon === 'boolean' ? <IconSvg width={24} height={24} component='NotificationBannerWarning' /> : icon}
          </Box> : null}

        {type === 'info' && icon ? <Box sx={{
        width: 24,
        minWidth: 24
      }}>
            {typeof icon === 'boolean' ? <InfoTwoToneIcon /> : icon}
          </Box> : null}
        {children}
      </Stack>
    </Stack>;
};
export default NotificationBanner;